import React from 'react';
import PropTypes from 'prop-types';

const SettingsTrigger = ({ onOpenModal }) => (
  <button type="button" data-testid="setting-trigger" onClick={onOpenModal}>
    <i className="icon icon-settings font-16 in-blue-500 mb-10" />
  </button>
);

SettingsTrigger.propTypes = {
  onOpenModal: PropTypes.func.isRequired
};

export default SettingsTrigger;
